module.exports = __webpack_public_path__ + "static/media/fb-circle-logo.11d5b6ba.svg";